import {error_box, loading} from "../functions/functions";
import {show_front_expert_orders} from "./show_front_expert_orders";
import {show_edit_expert_modal} from "./show_edit_expert_modal";

export function get_projects_of_users()
{
    if( document.querySelector( '.experts_panel_contents' ) )
    {
        let fieldPart = false;
        let allFields = false;

        if( document.querySelector( '.expert_field_parts' ) ) {
            fieldPart = document.querySelector('.expert_field_parts');
            allFields = fieldPart.querySelectorAll( 'a' );
        }
        let field = false;
        if( allFields ) {
            allFields.forEach(field_icon => {
                if (field_icon.classList.contains('selected')) {
                    field = field_icon;
                }
            });
        }else{
            field = document.querySelector( '.experts_panel_contents' );
        }
        let tbodyOfProjects = document.querySelector( '.experts_projects_table' );
        let tbodyOfUsers = document.querySelector( '.experts_users_table' );
        let pageNumber = document.querySelector( '.project_container .page_number_section p .page_number' );
        let perPage = document.querySelector( '.project_container select#per_page_select' );
        let nextPage = document.querySelector( '.project_container .navigation_buttons .button_next' );
        let prevPage = document.querySelector( '.project_container .navigation_buttons .button_prev' );
        let nextUsers = document.querySelector( '.user_container .navigation_buttons .button_next' );
        let prevUsers = document.querySelector( '.user_container .navigation_buttons .button_prev' );
        let userPerPage = document.querySelector( '.user_container select#per_page_select' );
        let userPageNumber = document.querySelector( '.user_container .page_number_section p .page_number' );
        let newPage = Number( pageNumber.innerHTML.trim() );
        let newUserPage = Number( userPageNumber.innerHTML.trim() );
        let searchInput = document.getElementById( 'search_input_for_projects' );
        let userSearchInput = document.getElementById( 'search_input_for_users' );
        let searchString = searchInput.value;
        let userSearchString = userSearchInput.value;
        let dataForAjax = {
            allFields : allFields,
            tbodyOfProjects : tbodyOfProjects,
            tbodyOfUsers : tbodyOfUsers,
            fieldPart : fieldPart,
            pageNumber : pageNumber,
            newPage : newPage,
            perPage : perPage.value,
            searchProject : searchString,
            searchUser : userSearchString,
            selectChanged : false,
            userPageNumber : userPageNumber,
            newUserPage : newUserPage,
            userPerPage : userPerPage.value,
            field : field,
            status : false,
            accessLevel : document.querySelector( '.experts_panel_contents' ).dataset.accesslevel
        }
        userSearchInput.addEventListener( 'keyup', ()=>{
            if( userSearchInput.value.trim() !== '' ){
                dataForAjax.searchUser = userSearchInput.value;
                dataForAjax.newUserPage = 1;
                dataForAjax.selectChanged = false;
                get_projects_ajax( dataForAjax  );
            }else{
                dataForAjax.searchUser = false;
                dataForAjax.newUserPage = 1;
                dataForAjax.selectChanged = false;
                dataForAjax.status = 'getUser';
                get_projects_ajax( dataForAjax  );
            }
        } );
        searchInput.addEventListener( 'keyup', () => {
            if( searchInput.value.trim()!== '' )
            {
                dataForAjax.searchProject = searchInput.value;
                if( document.querySelector( '.experts_panel_contents' ) ) {
                    document.querySelectorAll('.expert_field_parts a.icon_link').forEach(field_icon => {
                        if (field_icon.classList.contains('selected')) {
                            field = field_icon;
                        }
                    });
                }else{
                    field = document.querySelector( '.experts_panel_contents' ).dataset.field;
                }
                if( field ){
                    dataForAjax.newPage = 1;
                    dataForAjax.field = field;
                    dataForAjax.selectChanged = false;
                    get_projects_ajax( dataForAjax );
                }else{
                    error_box( 'عدم انتخاب رشته', 'هیچ رشته ای برای جستجو انتخاب نشده است.', 'error', 30 );
                }
            }else{
                dataForAjax.searchProject = false;
                dataForAjax.newPage = 1;
                dataForAjax.selectChanged = false;
                dataForAjax.status = 'getProject';
                get_projects_ajax( dataForAjax  );
            }
        } );
        perPage.addEventListener( 'change', ()=>{
            dataForAjax.perPage = perPage.value;
            dataForAjax.newPage = 1;
            dataForAjax.selectChanged = false;
            dataForAjax.status='getProject';
            get_projects_ajax( dataForAjax );
        } );
        userPerPage.addEventListener( 'change', ()=>{
            dataForAjax.userPerPage = userPerPage.value;
            dataForAjax.newUserPage = 1;
            dataForAjax.selectChanged = false;
            dataForAjax.status='getUser';
            get_projects_ajax( dataForAjax );
        } );
        nextUsers.addEventListener( 'change', ()=>{
            dataForAjax.newUserPage = Number( userPageNumber.innerHTML.trim() );
            dataForAjax.newUserPage += 1;
            dataForAjax.selectChanged = false;
            dataForAjax.status='getUser';
            get_projects_ajax( dataForAjax );
        } );
        prevUsers.addEventListener( 'change', ()=>{
            dataForAjax.newUserPage = Number( userPageNumber.innerHTML.trim() );
            dataForAjax.newUserPage -= 1;
            dataForAjax.newUserPage = ( dataForAjax.newUserPage < 1 ) ? 1 : dataForAjax.newUserPage;
            dataForAjax.selectChanged = false;
            dataForAjax.status='getUser';
            get_projects_ajax( dataForAjax );
        } );
        nextPage.addEventListener( 'click', ()=>{
            dataForAjax.newPage = Number( pageNumber.innerHTML.trim() );
            dataForAjax.newPage += 1;
            dataForAjax.selectChanged = false;
            dataForAjax.status='getProject';
            get_projects_ajax( dataForAjax );
        } );
        prevPage.addEventListener( 'click', ()=>{
            dataForAjax.newPage = Number( pageNumber.innerHTML.trim() );
            dataForAjax.newPage -= 1;
            dataForAjax.newPage = ( dataForAjax.newPage < 1 ) ? 1 : dataForAjax.newPage;
            dataForAjax.selectChanged = false;
            dataForAjax.status='getProject';
            get_projects_ajax( dataForAjax );
        } );
        if( allFields ) {
            allFields.forEach(field => {
                field.addEventListener('click', fieldEvent => {
                    fieldEvent.preventDefault();
                    if (document.querySelector('.project_container').classList.contains('hide')) {
                        document.querySelector('.project_container').classList.remove('hide');
                        document.querySelector('.user_container').classList.remove('hide');
                    }
                    if (!field.classList.contains('selected')) {
                        tbodyOfProjects.innerHTML = `<tr><td colspan="4">${loading()}</td></tr>`;
                        tbodyOfUsers.innerHTML = `<tr><td colspan="4">${loading()}</td></tr>`;
                        dataForAjax.selectChanged = true;
                        dataForAjax.field = field;
                        get_projects_ajax(dataForAjax);
                    }
                });
            });
        }
    }
}

export function get_projects_ajax( { allFields,tbodyOfProjects,tbodyOfUsers, fieldPart, pageNumber, newPage,perPage,searchProject=false,searchUser=false,selectChanged=false,userPageNumber,newUserPage,userPerPage, field, status, accessLevel = false } )
{
    let data = {
        action: ( ( fieldPart ) ? fieldPart.dataset.action : document.querySelector( '.experts_panel_contents' ).dataset.action ),
        nonce: ( ( fieldPart ) ? fieldPart.dataset.nonce : document.querySelector( '.experts_panel_contents' ).dataset.nonce ),
        userid: ( ( fieldPart ) ? fieldPart.dataset.userid : document.querySelector( '.experts_panel_contents' ).dataset.userid ),
        perPage : perPage,
        pageNumber : newPage,
        userPerPage : userPerPage,
        newUserPage : newUserPage,
        accessLevel : accessLevel
    };
    data = ( searchProject ) ? { ...data, searchProject: searchProject } : data;
    data = ( searchUser ) ? { ...data, searchUser: searchUser } : data;
        if( selectChanged ){
            tbodyOfProjects.innerHTML = `<tr><td colspan="4">${loading()}</td></tr>`;
            tbodyOfUsers.innerHTML = `<tr><td colspan="4">${loading()}</td></tr>`;
        }else{
            if( searchProject || status === 'getProject' ){
                tbodyOfProjects.innerHTML = `<tr><td colspan="4">${loading()}</td></tr>`;
            }
            if( searchUser || status === 'getUser' ){
                tbodyOfUsers.innerHTML = `<tr><td colspan="4">${loading()}</td></tr>`;
            }
        }
        jQuery.ajax({
            url: ( fieldPart ) ? fieldPart.dataset.url : document.querySelector('.experts_panel_contents').dataset.url,
            method: "POST",
            data: { ...data, field: field.dataset.field },
            error: res => {
                console.log(res);
            },
            success: res => {
                let result = JSON.parse( res );
                if( selectChanged ){
                    allFields.forEach(the_field => {
                        if (the_field.classList.contains('selected')) {
                            the_field.classList.remove('selected');
                        }
                    });
                    field.classList.add('selected');
                    tbodyOfProjects.innerHTML = result.projects;
                    tbodyOfUsers.innerHTML = result.users;
                }else{
                    if( searchProject || status === 'getProject' ){
                        if( result.projects === 'false' )
                        {
                            tbodyOfProjects.innerHTML = '';
                            error_box( 'عدم وجود پروژه', 'پروژه ای جهت نمایش موجود نیست.', 'error', 50 );
                        }else{
                            pageNumber.innerHTML = newPage;
                            tbodyOfProjects.innerHTML = result.projects;
                        }
                    }
                    if( searchUser || status === 'getUser' ){
                        if( result.users === 'false' )
                        {
                            tbodyOfUsers.innerHTML = '';
                            error_box( 'عدم وجود کاربر', 'کاربری جهت نمایش موجود نیست.', 'error', 50 );
                        }else{
                            pageNumber.innerHTML = newPage;
                            tbodyOfUsers.innerHTML = result.users;
                        }
                    }
                }
                show_front_expert_orders();
                show_edit_expert_modal();
            }
        });
}